// src/components/BattleScreen/BattleAnimations/CrunchAnimation.jsx
import { useEffect, useRef } from 'react';
import './CrunchAnimation.css';

export default function CrunchAnimation({ playerRef, opponentRef, onComplete }) {
  const animRef = useRef(null);

  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const o = opponentEl.getBoundingClientRect();
    const container = playerEl.parentElement;
    const containerRect = container.getBoundingClientRect();

    // Center of opponent sprite
    const frameWidth = 156;
    const frameHeight = 146.5;
    const centerX = o.left - containerRect.left + o.width / 2;
    const centerY = o.top - containerRect.top + o.height / 2;

    // Create and position animation element
    const anim = document.createElement('div');
    anim.className = 'crunch-anim';
    anim.style.setProperty('--sx', `${centerX - frameWidth / 2}px`);
    anim.style.setProperty('--sy', `${centerY - frameHeight / 2}px`);
    container.appendChild(anim);
    animRef.current = anim;

    // Add spark at 500ms (frame 5 — snap impact)
    const sparkTimer = setTimeout(() => {
      const spark = document.createElement('div');
      spark.className = 'crunch-spark';
      spark.style.left = `${centerX}px`;
      spark.style.top = `${centerY}px`;
      container.appendChild(spark);

      // Remove spark after animation
      setTimeout(() => spark.remove(), 400);
    }, 500);

    // Remove animation after full duration
    const doneTimer = setTimeout(() => {
      anim.remove();
      onComplete();
    }, 800);

    // Cleanup
    return () => {
      clearTimeout(sparkTimer);
      clearTimeout(doneTimer);
      anim.remove();
      document.querySelectorAll('.crunch-spark').forEach(s => s.remove());
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

CrunchAnimation.moveType = 'dark';
